import React, { useState } from "react";
import Slider, { SliderTooltip } from "rc-slider";
import "rc-slider/assets/index.css";
import "./controlSlider.css";

const { Handle } = Slider;

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <SliderTooltip
      prefixCls="rc-slider-tooltip"
      overlay={`${value}°`}
      visible={dragging}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} style={{ padding: "6px" }} />
    </SliderTooltip>
  );
};

const sideLabel = {
  color: "rgb(20,20,20)",
  fontSize: "16px",
};

const marks = {
  0: {
    style: sideLabel,
    label: <strong>0</strong>,
  },
  120: "120°",
  240: "240°",
  360: {
    style: sideLabel,
    label: <strong>360</strong>,
  },
};

const ControlSlider = (props) => {
  // const [SliderValue, setSlider] = useState(30);
  // //   let SliderValue = 0;
  // const addSlider = () => {
  //   let newValue = SliderValue < 360 ? SliderValue + 5 : 360;
  //   setSlider(newValue);
  // };
  // const subtractSlider = () => {
  //   let newValue = SliderValue > 0 ? SliderValue - 5 : 0;
  //   setSlider(newValue);
  // };

  return (
    <div style={{ margin: "14px 0 0 0" }}>
      {" "}
      <h4>Control</h4>
      <div style={{ padding: "10px 35px 10px 5px" }}>
        <Slider
          min={0}
          max={360}
          step={5}
          marks={marks}
          value={props.sliderValue}
          handle={handle}
          trackStyle={{ backgroundColor: "#3FE2DC", height: 10 }}
          handleStyle={{
            borderColor: "blue",
            height: 28,
            width: 28,
            marginLeft: -14,
            marginTop: -9,
            backgroundColor: "black",
          }}
          railStyle={{ backgroundColor: "rgb(80,80,80,0.1)", height: 10 }}
        />
        {/* <Range /> */}
        <br />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "20px 0",
          }}
        >
          <button
            onClick={props.subtractSlider}
            className="buttonSlider subtract"
          >
            Subtract
          </button>
          <span
            style={{
              fontSize: "1.45em",
              fontWeight: "bold",
              padding: "6px 0 0 0 ",
            }}
          >
            {props.sliderValue}°
          </span>
          <button onClick={props.addSlider} className="buttonSlider">
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default ControlSlider;
